// extracted by mini-css-extract-plugin
export default {"UnprotectedView":"UnprotectedView_UnprotectedView__TS+hf","switcher":"UnprotectedView_switcher__GQz+j","authors":"UnprotectedView_authors__cj0ef"};